import initialState from "./windrowRegistration.state.js";
import actions from "./windrowRegistration.actions.js";
import mutations from "./windrowRegistration.mutations.js";
import getters from "./windrowRegistration.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
